<template>
  <div>
    <list
      row-key="Id"
      ref="list"
      unit="考勤明细"
      :page="false"
      :query-params="params"
      :show-query="showQuery"
      :get-data-func="api.getStudentStat"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期">
          <el-select v-model="params.TermId" size="mini" @change="setSection">
            <template v-for="(i,index) in terms">
              <el-option :key="index" :value="i.TermId" :label="i.TermName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="~"
            size="mini"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :style="isMB?'width:220px;':'width: 250px;'"
            value-format="yyyy/MM/dd"
            unlink-panels
            :editable="false"
            :clearable="false"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="节次">
          <el-select v-model="params.SectionNumber" size="mini" clearable>
            <template v-for="(i,index) in sections">
              <el-option :key="index" :value="i.SectionId" :label="i.SectionName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" size="mini" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" size="mini" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input size="mini" v-model="params.FullName" placeholder="请输入学生姓名" clearable />
        </el-form-item>
        <el-form-item label="课堂类型">
          <el-select size="mini" v-model="params.RollCallType" clearable>
            <el-option :value="1" label="常规课堂"></el-option>
            <el-option :value="0" label="早晚课堂"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="ClassName" label="班级" align="center"/>
        <el-table-column prop="FullName" label="姓名" align="center" min-width="100" />
        <el-table-column prop="Sex" label="性别" align="center">
          <template slot-scope="{row}">
            <span v-if="row.Sex==1">男</span>
            <span v-else-if="row.Sex==2">女</span>
          </template>
        </el-table-column>
        <el-table-column prop="Total" label="合计" align="center" min-width="90" />
        <el-table-column prop="Bj" label="病假" align="center">
          <template slot-scope="{row}">
            {{row.Bj>0?row.Bj:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Sj" label="事假" align="center">
          <template slot-scope="{row}">
            {{row.Sj>0?row.Sj:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Zd" label="走读" align="center">
          <template slot-scope="{row}">
            {{row.Zd>0?row.Zd:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Yw" label="医务" align="center">
          <template slot-scope="{row}">
            {{row.Yw>0?row.Yw:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Xl" label="心理" align="center">
          <template slot-scope="{row}">
            {{row.Xl>0?row.Xl:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Xnjs" label="校本课程" align="center">
          <template slot-scope="{row}">
            {{row.Xnjs>0?row.Xnjs:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Gj" label="公假" align="center">
          <template slot-scope="{row}">
            {{row.Gj>0?row.Gj:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Qt" label="校内其他" align="center">
          <template slot-scope="{row}">
            {{row.Qt>0?row.Qt:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Cd" label="迟到" align="center">
          <template slot-scope="{row}">
            {{row.Cd>0?row.Cd:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Ycqq" label="异常缺勤" align="center">
          <template slot-scope="{row}">
            {{row.Ycqq>0?row.Ycqq:""}}
          </template>
        </el-table-column>
        <el-table-column prop="Zcqq" label="其他正常缺勤" align="center">
          <template slot-scope="{row}">
            {{row.Zcqq>0?row.Zcqq:""}}
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  computed: {
    dateRange: {
      get() {
        return [this.params.StartDate, this.params.EndDate];
      },
      set(value) {
        console.log(value);
        if (value) {
          this.params.StartDate = value[0];
          this.params.EndDate = value[1];
          this.$refs.list.initParams.StartDate = value[0];
          this.$refs.list.initParams.EndDate = value[1];
        }
      },
    },
  },
  data() {
    return {
      api: require("@/api/at/attendance").default,
      section_api: require("@/api/ed/section").default,
      term_api: require("@/api/ed/term").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      params: {
        StartDate: this.$commonJs.getToday(),
        EndDate: this.$commonJs.getToday(),
        SectionNumber: null,
        ClassId: null,
        GradeId: null,
        ClassName: "",
        FullName: "",
        RollCallType: 1,
        TermId: 0,
      },
      terms: [], //学期列表
      sections: [], //课程节次列表
      grades: [],
      classes: [],
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    begin() {
      this.setParams();
    },
    setParams() {
      let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
      this.term_api.list().then((res) => {
        this.terms = res.Data;
        if (this.terms.length > 0) {
          this.params.TermId = loginInfo.TermId;
          if(!this.params.TermId) {
            this.params.TermId = this.terms[0].TermId;
          }
          this.$refs.list.initQueryParams.TermId = this.params.TermId;
          this.setSection();
        }
      });
    },
    setSection() {
      this.getGrade();
      this.query(this.params);
      this.sections = [];
      this.sections.push({ SectionId: 0, SectionName: "早读" });
      for (let i = 1; i <= 15; i++) {
        this.sections.push({
          SectionId: i,
          SectionName: "第" + i + "节课",
        });
      }
      // this.section_api.list({ TermId: this.params.TermId }).then((res) => {
      //   console.log("sections", res);
      //   if (res.Data != null && res.Data.length > 0) {
      //     this.sections = res.Data;
      //     // this.params.SectionId = this.sections[0].SectionId;
      //     // this.$refs.list.initQueryParams.SectionId = this.params.SectionId;
      //   }
      // });
    },
    getGrade() {
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
        this.getClass();
      });
    },
    getClass() {
      this.params.ClassId = null;
      if(!this.params.GradeId) {
        this.classes = [];
        return;
      }
      var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
      this.class_api.list(params).then((res) => {
        this.params.ClassId = null;
        this.classes = res.Data;
      });
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      var params = this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams);
      this.api.exportStudentStat(params).then(() => {
        loading.close();
      });
    },
  },
};
</script>